import { combineReducers } from "redux";
import loginSlice from "./slices/loginSlice";
import usersSlice from "./slices/User/usersSlice";
import formSlice from "./slices/formSlice";
import userRoleSlice from "./slices/User/userRoleSlice";
import userDesignationSlice from "./slices/User/userDesignationSlice";
import organizationSlice from "./slices/Organization/OrganizationSlice";
import UserRoleRouteSlice from "./slices/UserRoute/UserRoleRouteSlice";
import checklistSlice from "./slices/Checklist/checklistSlice";
import caseSlice from "./slices/Case/caseSlice";
import allotmentDocumentSlice from "./slices/AllotmentDocuments/allotmentDocumentSlice";
import templateGroupingSlice from "./slices/TemplateGrouping/TemplateGroupingSlice";
import ChecklistDocumentSlice from "./slices/ChecklistDocuments/ChecklistDocumentSlice";
import empanelmentSlice from "./slices/Empanelment/empanelmentSlice";
import organizationRegionSlice from "./slices/OrganizationRegion/OrganizationRegionSlice";
// import meetingSlice from "./slices/Meeting/meetingSlice";
// import noticeTemplateSlice from "./slices/NoticeTemplate/NoticeTemplateSlice";
import dashboardSlice from "./slices/Dashboard/DashboardSlices";
import boardsAndPanelSlice from "./slices/boardsAndPanel/boardsAndPanelSlice";
import CaseTaskSlice from "../redux/slices/Task/CaseTaskSlices";
import caseDocumentsSlice from "../redux/slices/CaseDocuments/caseDocumentsSlice";
import tenantSlice from './slices/Tenant/TenantSlice'
import noticeTemplateSlice from "./slices/NoticeTemplate/noticeTemplateSlice";
import ticketsSlice from "../redux/slices/Tickets/ticketsSlices";


export const rootReducer = combineReducers({
  tenant:tenantSlice,
  empanelment: empanelmentSlice,
  login: loginSlice,
  users: usersSlice,
  formData: formSlice,
  userRoles: userRoleSlice,
  userDesignation: userDesignationSlice,
  organization: organizationSlice,
  organizationRegion: organizationRegionSlice,
  userRoleRouters: UserRoleRouteSlice,
  checklist: checklistSlice,
  ChecklistDocument: ChecklistDocumentSlice,
  case: caseSlice,
  templateGroupting: templateGroupingSlice,
  allotmentDocument: allotmentDocumentSlice,
  BoardsAndPanel:boardsAndPanelSlice,
  noticeTemplate:noticeTemplateSlice,
  dashboard: dashboardSlice,
  caseTask: CaseTaskSlice,  
  caseDocuments: caseDocumentsSlice,
  tickets: ticketsSlice,
});
